import apiClient from './apiClient';

// ============================================================
// Types — aligned with backend/modules/pw220a/models/pw220a.go
// ============================================================

export interface F21A0 {
  f21a0_01: string;        // 調整單號
  f21a0_07: string;        // 庫號
  f21a0_10: string;        // 部門代號
  f21a0_11: string | null; // 調整日期
  f21a0_12: string;        // 人員代號
  f21a0_13: string;        // 說明1
  f21a0_14: string;        // 說明2
  f21a0_15: string;        // 說明
  f21a0_16: number;        // 總項數
  f21a0_17: number;        // 總金額
  f21a0_18: string;        // 調整類別
  f21a0_19: number;
  f21a0_20: number;
  f21a0_21: number;
  f21a0_23: number;
  f21a0_24: number;
  f21a0_25: number;
  f21a0_26: number;
  f21a0_30: string;        // 備註
  f21a0_31: string;        // 跳號別 (' ' / 'M' / 'P')
  f21a0_33: string;        // 核准人員
  f21a0_34: string | null; // 核准日期
  f21a0_80: string;        // 核准狀態 ('N'=未核准, 'P'=已核准)
  f21a0_81: string;        // 核准者
  f21a0_82: string | null; // 核准時間
  f21a0_90: number;        // Version
  f21a0_91: string;        // 修改者
  f21a0_92: string | null; // 修改時間
  f21a0_93: string;        // 建立者
  details?: F21A1[];
}

export interface F21A1 {
  f21a1_01: string;        // 調整單號 (FK)
  f21a1_02: number;        // 明細序號
  f21a1_07: string;        // 庫號（存檔時由單頭回寫）
  f21a1_11: string;        // 產品代號
  f21a1_11a: string;       // 產品名稱（自動回填）
  f21a1_12: string;        // 單位（自動回填）
  f21a1_13: number;        // 數量
  f21a1_14: number;        // 單價
  f21a1_15: number;        // 金額（= ROUND(數量*單價, 2)）
  f21a1_16: number;        // 贈量
  f21a1_17: number;
  f21a1_18: string;        // 明細摘要
  f21a1_19: number;
  f21a1_21: string;        // 訂單編號
  f21a1_22: number;        // 訂單序號
  f21a1_90: number;        // Version
  f21a1_91: string;        // 修改者
  f21a1_92: string | null; // 修改時間
  f21a1_93: string;        // 建立者
}

export interface CreatePW220ARequest {
  master: Omit<F21A0, 'details'>;
  details: F21A1[];
}

export interface UpdatePW220ARequest {
  master: Omit<F21A0, 'details'>;
  details: F21A1[];
}

export interface ListPW220AResponse {
  data: F21A0[];
  total: number;
  page: number;
  size: number;
}

// 核准狀態
export const STATUS_MAP: Record<string, { label: string; color: string }> = {
  N: { label: '未核准', color: 'default' },
  P: { label: '已核准', color: 'success' },
};

// 跳號別選項
export const JUMP_TYPE_OPTIONS = [
  { value: ' ', label: '日期格式（220A）' },
  { value: 'M', label: '月份格式（F01M）' },
  { value: 'P', label: 'P月份格式（F01P）' },
];

// ============================================================
// API methods
// ============================================================

const BASE = '/api/pw220a';

export const pw220aApi = {
  async list(page = 1, size = 500): Promise<ListPW220AResponse> {
    const res = await apiClient.get<ListPW220AResponse>(BASE, { params: { page, size } });
    return res.data;
  },

  async getByID(id: string): Promise<F21A0> {
    const res = await apiClient.get<F21A0>(`${BASE}/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: CreatePW220ARequest): Promise<F21A0> {
    const res = await apiClient.post<F21A0>(BASE, data);
    return res.data;
  },

  async update(id: string, data: UpdatePW220ARequest): Promise<F21A0> {
    const res = await apiClient.put<F21A0>(`${BASE}/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`${BASE}/${encodeURIComponent(id)}`);
  },
};

export default pw220aApi;
